import { Injectable, Injector } from '@angular/core';



import { $frontendTypes } from './Notifications.frontend.types'

@Injectable({ providedIn: 'root' })
export class Notifications_FrontendFlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public Notifications: Notifications_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
